export default __webpack_public_path__ + "static/media/WhiteContact.610e435a.svg";